import useToggle from 'academy-common-lib/hooks/useToggle';
import styled from 'academy-common-lib/utils/Styling';
import MobileTopFilterPanel from '../../../containers/TracksPage/MobileTopFilterPanel';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import { usePlaylistItemsSearch } from '../playlistItemsHooks';
import { Button } from 'foundations-components/transitional/components/Button';
import { FilterIcon } from 'foundations-assets';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterPanel = styled(MobileTopFilterPanel).withConfig({
  displayName: "PlaylistMobileFilter__FilterPanel",
  componentId: "sc-16e16xc-0"
})(["z-index:2222;"]);
export const PlaylistMobileFilterButton = () => {
  const {
    isShowing,
    show,
    hide
  } = useToggle();
  const {
    totalCount
  } = usePlaylistItemsSearch();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      "aria-label": I18n.text('learningCenter.filters.filtersLink'),
      "data-test-id": "mobile-filter-panel-button",
      marginBlockEnd: "200",
      onClick: show,
      paddingInline: "0 !important",
      responsive: false,
      use: "transparent",
      children: /*#__PURE__*/_jsx(FilterIcon, {
        color: "icon-core-subtle",
        size: "600"
      })
    }), /*#__PURE__*/_jsx(FilterPanel, {
      "data-test-id": "mobile-secondary-filter-panel",
      itemsCount: totalCount,
      mobileFilterTypes: [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.LEVEL, FILTER_TYPES.DURATION, FILTER_TYPES.CONTENT_TYPE, FILTER_TYPES.LANGUAGE],
      onCloseClick: hide,
      open: isShowing,
      showSort: false
    })]
  });
};